exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".container-store[data-v-98c3abc6]{padding:0;margin:0;width:100%;height:100vh;background-color:#fff;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column}.tab-header[data-v-98c3abc6]{width:100%;border:none;overflow-x:scroll}.main-box[data-v-98c3abc6]{height:calc(100vh - 50px);width:100%;overflow-y:scroll}.main-box[data-v-98c3abc6]::-webkit-scrollbar{width:10px;height:10px;visibility:hidden}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-98c3abc6","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/pages/Store.vue
// module id = Wyjd
// module chunks = 3